import PropTypes from 'prop-types';
import React from 'react';
import styles from './TopBackground.module.css';
export default function TopBackground(_a) {
    var width = _a.width, backgroundColor = _a.backgroundColor;
    return (React.createElement("div", { className: styles.topBackground },
        React.createElement("div", { className: styles.inner, style: { backgroundColor: backgroundColor, width: width } })));
}
TopBackground.propTypes = {
    width: PropTypes.number,
    backgroundColor: PropTypes.string,
};
